import { useGetLocale, useSetLocale } from '@refinedev/core';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const languageOptions = [
  {
    label: 'Polski',
    value: 'pl',
  },
  {
    label: 'English',
    value: 'en',
  },
];

export const LanguageSwitcher = () => {
  const locale = useGetLocale();
  const changeLanguage = useSetLocale();

  const currentLocale = locale();

  return (
    <Select
      value={currentLocale}
      onChange={changeLanguage}
      options={languageOptions}
      style={{ width: 120 }}
      suffixIcon={<GlobalOutlined />}
      size="small"
    />
  );
};
